import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, CardHeader, CardTitle, PageHeader, Badge } from '@/components/ui'
import { Check } from 'lucide-react'

export const Route = createFileRoute('/_app/plans')({
  component: PlansPage,
})

const PLANS = [
  {
    name: 'Starter',
    slug: 'starter',
    price: 'Gratis',
    description: 'Para validar el modelo y arrancar.',
    color: 'border-neutral-700',
    features: [
      '100 productos',
      '500 pedidos/mes',
      '5 GB storage',
      '10 GB bandwidth',
      '100K API requests/mes',
      '3 usuarios del panel',
    ],
  },
  {
    name: 'Growth',
    slug: 'growth',
    price: '$49 USD/mes',
    description: 'Tienda en operación con tracción.',
    color: 'border-blue-700',
    features: [
      '1.000 productos',
      '5.000 pedidos/mes',
      '50 GB storage',
      '100 GB bandwidth',
      '1M API requests/mes',
      '10 usuarios del panel',
      'Webhooks salientes',
      'Custom domain (Cloudflare for SaaS)',
    ],
  },
  {
    name: 'Enterprise',
    slug: 'enterprise',
    price: 'Custom',
    description: 'Marcas con volumen alto y necesidades especiales.',
    color: 'border-emerald-700',
    features: [
      '100.000 productos',
      '100.000 pedidos/mes',
      '500 GB storage',
      '1 TB bandwidth',
      '10M API requests/mes',
      '100 usuarios del panel',
      'SLA con soporte 24/7',
      'White-label app móvil opcional',
      'Multi-region read replicas',
    ],
  },
]

function PlansPage() {
  return (
    <>
      <PageHeader
        title="Planes"
        description="Tiers ofrecidos a tenants de la plataforma"
      />
      <div className="p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PLANS.map((plan) => (
            <Card key={plan.slug} className={`border-2 ${plan.color}`}>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle>{plan.name}</CardTitle>
                  <Badge variant="muted">{plan.slug}</Badge>
                </div>
                <p className="text-2xl font-bold mt-2">{plan.price}</p>
                <p className="text-sm text-neutral-400 mt-1">{plan.description}</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm">
                      <Check className="size-4 text-green-500 shrink-0 mt-0.5" />
                      <span className="text-neutral-300">{f}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="mt-6 bg-yellow-900/10 border-yellow-800">
          <CardContent className="p-4">
            <p className="text-sm text-yellow-400 font-medium">⏸ En desarrollo</p>
            <p className="text-xs text-neutral-300 mt-1">
              Edición de planes y asignación a tenants llega cuando se integre Stripe Billing + Meters API.
              Por ahora los límites están hardcoded en core-api/src/modules/tenants/tenants.repository.ts.
            </p>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
